import { c as _c } from "react/compiler-runtime";
import { formatLargeNumber } from "@/helpers/Helpers";
import type { CreateWaveOutcomeConfig } from "@/types/waves.types";
export default function CreateWaveOutcomesRowCICApprove(t0) {
  const $ = _c(11);
  const {
    outcome,
    removeOutcome
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-col-span-2"><h3 className="tw-mb-0 tw-text-sm tw-font-semibold tw-text-white">NIC</h3></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = outcome.credit ?? 0;
  let t3;
  if ($[1] !== t2) {
    t3 = formatLargeNumber(t2);
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <div className="tw-col-span-7"><p className="tw-mb-0 tw-text-nowrap tw-text-sm tw-font-normal tw-text-white">{t3} NIC</p></div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg className="tw-h-5 tw-w-5 tw-flex-shrink-0" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== removeOutcome) {
    t6 = <div className="tw-col-span-1 tw-flex tw-justify-end"><button onClick={removeOutcome} aria-label="Remove" className="tw-flex tw-h-8 tw-w-8 tw-transform tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-error tw-transition tw-duration-300 tw-ease-out hover:tw-bg-error/10 focus:tw-scale-90">{t5}</button></div>;
    $[6] = removeOutcome;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <div className="tw-grid tw-w-full tw-grid-cols-10 tw-items-center tw-justify-between tw-gap-x-6 tw-rounded-lg tw-bg-gradient-to-r tw-from-primary-400/[0.15] tw-to-primary-400/[0.05] tw-px-5 tw-py-2 tw-ring-1 tw-ring-inset tw-ring-primary-400/10">{t1}{t4}{t6}</div>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}